<div class="container innerContent api-information-cards">
  <div class="row">
    <div class="card-container col-sm-12 col-lg-4 col-md-4" *ngFor="let connectCard of connectCard">
      <div class="card">
        <div class="image-tile-container">
          <div class="outer-tile">
            <div class="image-tile show-image" style="background-image: url('{{ connectCard.headImage }}');"></div>
          </div>
        </div>
        <h4 class="card-title">
          {{ connectCard.title }}
        </h4>
        <div class="api-information-card-body" (click)="handleCardBodyClick($event)" [innerHtml]="returnHtmlFromRichText(connectCard.richTextBody) | mdToHtml"></div>
      </div>
    </div>
  </div>
</div>
